/**
 * @generated SignedSource<<f9299b360d1c09f2ccaf3097b6b4781b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_businessList_ListViewRootWithSmartCard_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewRoot_queryFragment">;
  readonly " $fragmentType": "src_businessList_ListViewRootWithSmartCard_queryFragment";
};
export type src_businessList_ListViewRootWithSmartCard_queryFragment$key = {
  readonly " $data"?: src_businessList_ListViewRootWithSmartCard_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewRootWithSmartCard_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_businessList_ListViewRootWithSmartCard_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_businessList_ListViewRoot_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "d9c417a88c77b82987a401093871e680";

export default node;
